export default {
    update: {
        success: 'The company mega trend {title} was successfully saved'
    },
    create: {
        success: 'The company mega trend {title} was successfully saved'
    },
    delete: {
        success: 'The company mega trend was successfully deleted'
    }
}
